import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { selectors as userInfoSelectors } from '../../../common/userInfo';
import { selectors as pageInfoSelectors } from '../../../common/pageInfo';
import {
    selectors as bookmakersInfoSelectors,
    actions as bookmakersInfoActions,
} from '../../../common/bookmakersInfo';
import { actions as modalActions } from '../../../modals';
import * as drawerActions from '../../drawer.actions';
import { actions as betActions } from '../../../common/bet';
import {
    selectors as bookmakersListSelectors,
    actions as bookmakersListActions,
} from '../../../common/bookmakersList';
import BetForm from './components/BetForm';
import ActionBar from './components/ActionBar';
import ErrorBanner from '../../../common/errorBanner'
import ExpandPanel from '../../../common/expandPanel'
import MultipleForm from './components/MultipleForm';
import FTForm from './components/FTForm';
import { calculateTotalStake } from '../../../common/utils/calculateStake'
import { isForecastMultiple } from '../../../common/utils/multiplesReturns'
import * as multipleTypes from '../../../common/utils/multiples';
import { ERROR_CODES } from '../../../common/utils/apiErrors'
import { getShortGamblingCompliance } from '../../../common/gamblingCompliance'
import FreeBetsContainer from '../FreeBetsContainer'
import BlankErrorBoundary from '../../../common/errorBoundaries/BlankErrorBoundary'
import {
    logToAnalyticsRemoveSelectionClick,
    logToAnalyticsDiscardSlipButtonClick,
    findAnalytics,
} from '../../../App/analyticsTracking';
import Svg from '../../../common/svgIcon';
import './styles.scss';

const analytics = findAnalytics();
const selectionRemovedEvent = new CustomEvent('BETSLIP.SELECTION_REMOVED');

export class BetPage extends Component {

    constructor(props) {
        super(props);
        this.onCloseClick = this.onCloseClick.bind(this)
        this.onRemoveAll = this.onRemoveAll.bind(this)
    }

    componentWillMount() {
        const {
            isUserLoggedIn,
            getUserInfo,
            apiName,
            feed,
        } = this.props;

        if (isUserLoggedIn) {
            getUserInfo(apiName, feed)
        }
    }

    componentDidUpdate() {
        const {
            genericError,
            clearGenericError,
            userInfo,
            selectedBets,
            multiples,
        } = this.props;

        const totalStake = calculateTotalStake(selectedBets, multiples)

        if (
            genericError.errorId !== null &&
            genericError.errorId === ERROR_CODES.INSUFFICIENT_FUNDS &&
            userInfo.balance > totalStake
        ) {
            clearGenericError();
        }
    }

    onCloseClick(outcomersId) {
        const {
            deleteBet,
            selectedBets,
            updateObstructions,
            clearMultiples,
            cancelBuildMultiples,
            betslipID,
        } = this.props;

        const errors = selectedBets.reduce((acc, bet) => {
            if (bet.outcomersId !== outcomersId && bet.error.errorId !== null) {
                acc.push(bet.error.errorId);
            }
            return acc;
        }, []);

        cancelBuildMultiples();
        clearMultiples();
        updateObstructions(errors);
        deleteBet(outcomersId);
        if (analytics) {
            logToAnalyticsRemoveSelectionClick(betslipID, analytics);
        }
        document.dispatchEvent(selectionRemovedEvent);
    }

    onRemoveAll() {
        this.props.removeAllBets();
        if (analytics) {
            logToAnalyticsDiscardSlipButtonClick(this.props.betslipID, analytics);
        }
        document.dispatchEvent(selectionRemovedEvent);
    }

    renderActionBar() {
        const {
            userInfo,
            selectedBets,
            isUserLoggedIn,
            feed,
            minimizeQuickslip,
            isQuickslipMode,
            genericError,
            multiples,
            numberOfFreeBets,
            freeBetsEnabled,
            freeBetIsSelected,
            freeBetAmount,
        } = this.props;

        const totalStake = calculateTotalStake(selectedBets, multiples)
        const { currencySign } = userInfo;

        return (
            <ActionBar
                totalStake={totalStake}
                currencySign={currencySign}
                selectedBets={selectedBets}
                multiples={multiples}
                isUserLoggedIn={isUserLoggedIn}
                feed={feed}
                onAddToBetslip={minimizeQuickslip}
                isQuickslipMode={isQuickslipMode}
                genericError={genericError}
                numberOfFreeBets={numberOfFreeBets}
                freeBetsEnabled={freeBetsEnabled}
                freeBetIsSelected={freeBetIsSelected}
                freeBetAmount={freeBetAmount}
            />
        );
    }

    renderRemoveBar() {
        const {
            isQuickslipMode,
            isDrawerMinimized,
            selectedBets,
        } = this.props

        if (isQuickslipMode || isDrawerMinimized) {
            return null
        }

        return (
            <div className="bs-removeAll">
                <div>
                    <span className="bs-removeAll__label">Bet Slip</span>
                    <span className="bs-removeAll__badge">{selectedBets.length}</span>
                </div>
                {(selectedBets.length > 1) ? (
                    <button
                        className="bs-removeAll__button"
                        onClick={this.onRemoveAll}
                    >
                        Remove All
                    </button>
                ) : null}
            </div>
        )
    }

    renderBetForms(selectedBets) {
        const {
            isUserLoggedIn,
            userInfo: {
                currencySign,
            },
            isPlacingBet,
            setStake,
            setIsEachWay,
            setPriceType,
            name,
            isMobile,
            useDecimalOdds,
            setIsEditingStake,
            isQuickslipMode,
            clearError,
            setErrorOnBuild,
            setGlobalModal,
            toggleMultiplesInclusion,
            freeBetIsSelected,
            betslipID,
        } = this.props

        return (
            selectedBets.map(bet => (
                <BetForm
                    key={`bet-form-${bet.outcomersId}`}
                    className={classNames({
                        'bs-betForm__placing-bet': isPlacingBet,
                    })}
                    currencySign={currencySign}
                    {...bet}
                    useDecimalOdds={useDecimalOdds}
                    stakeValue={bet.stake}
                    isEachWay={bet.isEachWay}
                    isUserLoggedIn={isUserLoggedIn}
                    feed={bet.feed}
                    setStake={setStake}
                    setIsEachWay={setIsEachWay}
                    setPriceType={setPriceType}
                    onCloseClick={this.onCloseClick}
                    bookmakerName={name}
                    isMobile={isMobile}
                    numberOfBets={selectedBets.length}
                    isEditingStake={bet.isEditingStake}
                    setIsEditingStake={setIsEditingStake}
                    isQuickslipMode={isQuickslipMode}
                    isSuspended={bet.isSuspended}
                    associatedBet={bet.associatedBet}
                    clearError={clearError}
                    setErrorOnBuild={setErrorOnBuild}
                    setGlobalModal={setGlobalModal}
                    toggleMultiplesInclusion={toggleMultiplesInclusion}
                    freezeStake={bet.isLockedStake}
                    freeBetIsSelected={freeBetIsSelected}
                    betslipID={betslipID}
                />
            ))
        );
    }

    renderFreeBets() {
        const {
            isUserLoggedIn,
            selectedBets,
            numberOfFreeBets,
            userInfo: {
                currencySign,
            },
        } = this.props

        const FREEBETS_HEIGHT = 72;

        return (!isUserLoggedIn || selectedBets.length !== 1 || numberOfFreeBets === 0)
            ? null
            : (
                <ExpandPanel
                    title="Free Bets"
                    expandHeight={FREEBETS_HEIGHT}
                >
                    <FreeBetsContainer
                        currencySign={currencySign}
                    />
                </ExpandPanel>
            )
    }

    renderMultiples() {
        const {
            multiples,
            setGlobalModal,
            setStakeForMultiple,
            setIsEachWayForMultiple,
            setIsEditingStakeForMultiple,
            isMobile,
            isQuickslipMode,
            userInfo: {
                currencySign,
            },
            selectedBets,
            isBuildingMultiples,
            setMultiplesError,
            clearMultiplesError,
        } = this.props;

        const nonForecastMultiples = multiples.filter(multiple => (
            !isForecastMultiple(multiple.betType)
        ))

        const errors = nonForecastMultiples.filter(multiple => (
            multiple.error.message !== null
        ));

        const isKeypadExpanded = nonForecastMultiples.some(
            multiple => isMobile && multiple.isEditingStake === true,
        );

        const KEYPAD_HEIGHT = 88;
        const ERROR_HEIGHT = 34;
        const MULTIPLE_FORM_HEIGHT = 121;

        // Height of multiple forms...
        let expandHeight = nonForecastMultiples.length * MULTIPLE_FORM_HEIGHT;
        // Add height of the open errors...
        expandHeight += errors.length * ERROR_HEIGHT;
        // Add open keypad height...
        expandHeight += (isKeypadExpanded) ? KEYPAD_HEIGHT : 0;

        return (!isQuickslipMode) ? (
            <ExpandPanel
                title="Multiples"
                isLoading={isBuildingMultiples}
                expandHeight={expandHeight}
            >
                {
                    nonForecastMultiples.map(multiple => (
                        <MultipleForm
                            key={`bs-multipleForm${multiple.optionId}`}
                            setIsEachWayForMultiple={setIsEachWayForMultiple}
                            setIsEditingStake={setIsEditingStakeForMultiple}
                            setGlobalModal={setGlobalModal}
                            setStake={setStakeForMultiple}
                            currencySign={currencySign}
                            selectedBets={selectedBets}
                            isMobile={isMobile}
                            error={multiple.error}
                            betType={multiple.betType}
                            optionId={multiple.optionId}
                            isEachWay={multiple.isEachWay}
                            stakeValue={multiple.stakeValue}
                            numberLines={multiple.numberLines}
                            betSelections={multiple.betSelections}
                            isEditingStake={multiple.isEditingStake}
                            setMultiplesError={setMultiplesError}
                            clearMultiplesError={clearMultiplesError}
                            minStake={multiple.minStake}
                            maxStake={multiple.maxStake}
                        />
                    ))
                }
            </ExpandPanel>
        ) : null
    }

    renderForecastTricast() {
        const {
            setGlobalModal,
            multiples,
            selectedBets,
            changeSelectionOrder,
            userInfo: {
                currencySign,
            },
            isMobile,
            apiName,
            setStakeForMultiple,
            setIsEditingStakeForMultiple,
            setMultiplesError,
            clearMultiplesError,
            isBuildingMultiples,
        } = this.props;
        const forecastGroups = {};
        const forecastMultiples = multiples.filter(multiple => (
            isForecastMultiple(multiple.betType)
        ));
        const errors = forecastMultiples.filter(multiple => (
            multiple.error.message !== null
        ));
        const keyboardDisplayed = forecastMultiples.filter(multiple => (
            isMobile && multiple.isEditingStake
        )).length > 0;
        let panelHeight = 0;

        if (forecastMultiples.length > 0) {
            forecastMultiples.forEach((multiple) => {
                const eventId = multiple.betSelections.length > 0 ?
                    `${multiple.betSelections[0].eventId}-${multiple.betSelections[0].marketId}` :
                    '';
                const groupIsNew = !(eventId in forecastGroups);
                const order = multiple.betSelections.map(bet => bet.selectionId);
                const eventSelections = selectedBets.filter(selection => (
                    `${selection.eventId}-${selection.meetingId}` === eventId
                ));

                const orderedSelections = [];

                for (let i = 0; i < order.length; i += 1) {
                    const bet = eventSelections.find(selection =>
                        selection.outcomersId === order[i],
                    );
                    if (bet !== undefined) {
                        orderedSelections.push(bet);
                    }
                }

                if (groupIsNew) {
                    forecastGroups[eventId] = {
                        selections: [],
                        options: [],
                    };
                }

                switch (apiName) {
                    case 'williamhill': {
                        const duplicates = forecastGroups[eventId].options.filter(option => (
                            option.betType === multiple.betType
                        ));
                        if (duplicates.length === 0) {
                            forecastGroups[eventId].selections = orderedSelections;
                            forecastGroups[eventId].options.push(multiple);
                        }
                        break;
                    }
                    default: {
                        forecastGroups[eventId].selections = orderedSelections;
                        forecastGroups[eventId].options.push(multiple);
                    }
                }
            });

            Object.keys(forecastGroups).forEach((key) => {
                if (forecastGroups[key].selections.length > 0) {
                    if (forecastGroups[key].selections.length > 3) {
                        panelHeight += 89;
                    } else {
                        panelHeight += (forecastGroups[key].selections.length * 49) + 40;
                    }
                }
                if (forecastGroups[key].options.length > 0) {
                    panelHeight += (forecastGroups[key].options.length * 64) + 4;
                }
                panelHeight += 8;
            });

            panelHeight += errors.length * 30;

            if (keyboardDisplayed) {
                panelHeight += 84;
            }

            return (
                <ExpandPanel
                    title="Forecast & Tricast"
                    isLoading={isBuildingMultiples}
                    expandHeight={panelHeight}
                >
                    <FTForm
                        setGlobalModal={setGlobalModal}
                        groups={forecastGroups}
                        isMobile={isMobile}
                        currencySign={currencySign}
                        changeSelectionOrder={changeSelectionOrder}
                        setStake={setStakeForMultiple}
                        setIsEditingStake={setIsEditingStakeForMultiple}
                        setMultiplesError={setMultiplesError}
                        clearMultiplesError={clearMultiplesError}
                    />
                </ExpandPanel>
            );
        }

        return null;
    }

    renderMulpiplesDescription() {
        const {
            multiples,
        } = this.props;

        const hasForcastTricast = multiples
            .find(bet => multipleTypes.forecastMultiples.indexOf(bet.betType) > -1);

        const multipleDescriptionText = hasForcastTricast
            ? 'Ticked selections are included in multiple bets and fore/tricasts'
            : 'Ticked selections are included in multiple bets';

        return (
            <div className="bs-multiplesDescription">
                <div className="bs-multiplesDescription__tickContainer">
                    <Svg
                        iconName="multiples-tick"
                        size="Large"
                        className="bs-multiplesDescription__tick"
                    />
                </div>
                <div className="bs-multiplesDescription__text">{multipleDescriptionText}</div>
            </div>
        )
    }

    render() {
        const {
            selectedBets,
            isPlacingBet,
            isBetPlacedSuccessfully,
            isQuickslipMode,
            genericError,
            feed,
            freeBetsEnabled,
        } = this.props;

        if (isBetPlacedSuccessfully) {
            return <Redirect to="/bet-receipt" />;
        }

        if (selectedBets.length === 0 && !isQuickslipMode) {
            return (
                <div className="bs-horizontalSlider__element">
                    <div className="bs-drawer__content">
                        {this.renderRemoveBar()}
                        <div className="bs-drawer__empty">
                            <h2>Your Bet Slip is Empty</h2>
                            <span>Please add one or more selections to place a bet.</span>
                        </div>
                    </div>
                </div>
            )
        }

        const errorBanner = (isQuickslipMode && genericError.errorId !== null)
            ? <ErrorBanner message={genericError.message} />
            : null

        const shortGamblingCompliance = getShortGamblingCompliance(feed);

        const freeBets = (!isQuickslipMode && freeBetsEnabled)
            ? this.renderFreeBets()
            : null

        return (
            <div className="bs-horizontalSlider__element">
                <div
                    className={classNames({
                        'bs-drawer__content': true,
                        'bs-betPage__placing-bet': isPlacingBet,
                    })}
                >
                    <div className="bs-drawer__scrollable">
                        {this.renderRemoveBar()}
                        {errorBanner}
                        {this.renderBetForms(selectedBets)}
                        {this.renderMulpiplesDescription()}
                        <BlankErrorBoundary>
                            {this.renderMultiples()}
                        </BlankErrorBoundary>
                        <BlankErrorBoundary>
                            {this.renderForecastTricast()}
                        </BlankErrorBoundary>
                        <BlankErrorBoundary>
                            {freeBets}
                        </BlankErrorBoundary>
                        {this.renderActionBar()}
                        {!isQuickslipMode ? shortGamblingCompliance : null}
                    </div>
                </div>
            </div>
        );
    }
}

BetPage.defaultProps = {
    isUserLoggedIn: false,
    selectedBets: [],
    betslipID: null,
    multiples: [],
    topUpBookmakerUrl: '',
    feed: '',
    apiName: '',
    name: '',
    isTopUpIntegrated: false,
    genericError: {
        errorId: null,
        message: null,
    },
    freeBetsEnabled: false,
    freeBetAmount: null,
}

BetPage.propTypes = {
    isPlacingBet: PropTypes.bool.isRequired,
    isUserLoggedIn: PropTypes.bool,
    isBetPlacedSuccessfully: PropTypes.bool.isRequired,
    selectedBets: PropTypes.arrayOf(
        PropTypes.shape({
            outcomersId: PropTypes.string.isRequired,
            raceTime: PropTypes.string.isRequired,
            courseName: PropTypes.string.isRequired,
            horseName: PropTypes.string.isRequired,
            fractionalPrice: PropTypes.string.isRequired,
            decimalPrice: PropTypes.number, // SP-only bets will not have this
            isSpOnly: PropTypes.bool.isRequired,
            eachWayFraction: PropTypes.string,
            eachWayPlaces: PropTypes.string,
            priceType: PropTypes.string,
            isBog: PropTypes.string,
            isLockedStake: PropTypes.bool.isRequired,
        }),
    ),
    betslipID: PropTypes.string,
    userInfo: PropTypes.shape({
        name: PropTypes.string,
        balance: PropTypes.number,
        showBalance: PropTypes.bool,
        currencySign: PropTypes.string.isRequired,
    }).isRequired,
    feed: PropTypes.string,
    deleteBet: PropTypes.func.isRequired,
    setStake: PropTypes.func.isRequired,
    setIsEachWay: PropTypes.func.isRequired,
    setPriceType: PropTypes.func.isRequired,
    clearPlacedBetDetails: PropTypes.func.isRequired,
    useDecimalOdds: PropTypes.bool.isRequired,
    name: PropTypes.string,
    isMobile: PropTypes.bool.isRequired,
    getUserInfo: PropTypes.func.isRequired,
    isTopUpIntegrated: PropTypes.bool,
    topUpBookmakerUrl: PropTypes.string,
    onMinimizeClick: PropTypes.func.isRequired,
    setQuickslipMode: PropTypes.func.isRequired,
    isQuickslipMode: PropTypes.bool.isRequired,
    isBuildingMultiples: PropTypes.bool.isRequired,
    setIsEditingStake: PropTypes.func.isRequired,
    minimizeQuickslip: PropTypes.func.isRequired,
    removeAllBets: PropTypes.func.isRequired,
    isDrawerMinimized: PropTypes.bool.isRequired,
    genericError: PropTypes.shape({
        message: PropTypes.string,
        errorId: PropTypes.string,
    }),
    obstruction: PropTypes.string.isRequired,
    setBetObstruction: PropTypes.func.isRequired,
    clearGenericError: PropTypes.func.isRequired,
    clearError: PropTypes.func.isRequired,
    setErrorOnBuild: PropTypes.func.isRequired,
    setGlobalModal: PropTypes.func.isRequired,
    updateObstructions: PropTypes.func.isRequired,
    apiName: PropTypes.string,

    // Multiples
    setStakeForMultiple: PropTypes.func.isRequired,
    changeSelectionOrder: PropTypes.func.isRequired,
    setIsEachWayForMultiple: PropTypes.func.isRequired,
    setIsEditingStakeForMultiple: PropTypes.func.isRequired,
    multiples: PropTypes.arrayOf(
        PropTypes.shape({
            optionId: PropTypes.string.isRequired,
            betType: PropTypes.string.isRequired,
            minStake: PropTypes.number, // Not always available
            maxStake: PropTypes.number, // Not always available
            numberLines: PropTypes.number.isRequired,
            betSelections: PropTypes.arrayOf(
                PropTypes.shape({
                    selectionId: PropTypes.string.isRequired,
                    marketId: PropTypes.string.isRequired,
                    eventId: PropTypes.string.isRequired,
                }),
            ),
        }),
    ),
    toggleMultiplesInclusion: PropTypes.func.isRequired,
    clearMultiples: PropTypes.func.isRequired,
    setMultiplesError: PropTypes.func.isRequired,
    clearMultiplesError: PropTypes.func.isRequired,
    cancelBuildMultiples: PropTypes.func.isRequired,

    // Free bets
    freeBetsEnabled: PropTypes.bool,
    numberOfFreeBets: PropTypes.number.isRequired,
    freeBetIsSelected: PropTypes.bool.isRequired,
    freeBetAmount: PropTypes.number,
}

const userInfoSelector =
    userInfoSelectors.createUserInfoSelector(
        bookmakersInfoSelectors.betBookmakerSelector,
    );
const userIsLoggedInSelector = bookmakersListSelectors.createIsLoggedInSelector(
    bookmakersInfoSelectors.betBookmakerSelector,
);
const bookmakerInfoSelector = bookmakersListSelectors.createBookmakerInfoSelector(
    bookmakersInfoSelectors.betBookmakerSelector,
);

const mapStateToProps = (state, props) => {
    const {
        selectedBets,
        multiples,
        genericError,
        isBuildingMultiples,
        betslipID,
    } = state.bookmakersInfo;

    const {
        isPlacingBet,
        placedBetDetails,
        obstruction,
    } = state.bet;

    const {
        list,
        selectedFreeBet,
    } = state.freeBets
    const selectedFreeBetItem = selectedFreeBet
        ? list.find(freeBet => freeBet.id === selectedFreeBet)
        : null
    const freeBetAmount = selectedFreeBetItem
        ? selectedFreeBetItem.amount
        : null

    const isMobile = state.pageInfo.isPhone || state.pageInfo.isTablet;

    return {
        ...bookmakerInfoSelector(state, props),
        obstruction,
        isPlacingBet,
        isBuildingMultiples,
        isMobile,
        betslipID,
        isBetPlacedSuccessfully: placedBetDetails.bets.length !== 0,
        feed: bookmakersInfoSelectors.betBookmakerSelector(state),
        isUserLoggedIn: userIsLoggedInSelector(state),
        userInfo: userInfoSelector(state, props),
        useDecimalOdds: pageInfoSelectors.useDecimalOddsSelector(state),
        selectedBets,
        multiples,
        genericError,
        isQuickslipMode: state.drawerInfo.isQuickslipMode,
        isDrawerMinimized: state.drawerInfo.isDrawerMinimized,
        numberOfFreeBets: list.length,
        freeBetIsSelected: !!selectedFreeBet,
        freeBetAmount,
    }
}

const mapDispatchToProps = {
    clearPlacedBetDetails: betActions.clearPlacedBetDetails,
    deleteBet: bookmakersInfoActions.deleteBet,
    setStake: bookmakersInfoActions.setStakeForSelectedBet,
    setIsEachWay: bookmakersInfoActions.setIsEachWayForSelectedBet,

    setStakeForMultiple: bookmakersInfoActions.setStakeForMultiple,
    changeSelectionOrder: bookmakersInfoActions.changeSelectionOrder,
    setIsEachWayForMultiple: bookmakersInfoActions.setIsEachWayForMultiple,
    setIsEditingStakeForMultiple: bookmakersInfoActions.setIsEditingStakeForMultiple,

    setPriceType: bookmakersInfoActions.setPriceTypeForSelectedBet,
    getUserInfo: bookmakersListActions.getUserInfo,
    onMinimizeClick: drawerActions.minimizeDrawer,
    setQuickslipMode: drawerActions.setQuickslipMode,
    setIsEditingStake: bookmakersInfoActions.setIsEditingStake,

    minimizeQuickslip: drawerActions.minimizeQuickslip,
    removeAllBets: bookmakersInfoActions.removeAllBets,
    setBetObstruction: betActions.setBetObstruction,
    clearGenericError: bookmakersInfoActions.clearGenericError,
    clearError: bookmakersInfoActions.clearError,
    setErrorOnBuild: bookmakersInfoActions.setErrorOnBuild,
    setGlobalModal: modalActions.setGlobalModal,
    updateObstructions: betActions.updateObstructions,
    toggleMultiplesInclusion: bookmakersInfoActions.toggleMultiplesInclusion,
    clearMultiples: bookmakersInfoActions.clearMultiples,
    cancelBuildMultiples: bookmakersInfoActions.cancelBuildMultiples,
    setMultiplesError: bookmakersInfoActions.setMultiplesError,
    clearMultiplesError: bookmakersInfoActions.clearMultiplesError,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BetPage)



// WEBPACK FOOTER //
// /src/js/drawer/components/BetPage/BetPage.jsx